<template>
  <div 
    :class="baseSpinnerClasses" 
    class="base-spinner"
  >
    <div class="base-spinner__circle" />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["x-small", "small", "medium", "large"].includes(value),
  },
});

const baseSpinnerClasses = computed(() => ({
  [`base-spinner--size-${props.size}`]: true,
}));
</script>

<style lang="scss" scoped>
@import "./base-spinner.scss";
</style>
